import React from 'react';
import ErrorMessage from '../components/Error-message';
import {errorPage} from '../actions/mode';

export default class Page404 extends React.Component {

  static fetchData(dispatch) {
    return dispatch(errorPage('Page not found', 404));
  }

  render() {
    return (
      <div>
        <ErrorMessage is404></ErrorMessage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/Page-404.js